import initialData from '../data/initialState.json';
import {
  FETCH_CURRENT_REQUEST,
  FETCH_CURRENT_SUCCESS,
  FETCH_CURRENT_FAILED,
  SWITCH_TYPE,
} from './constants';
import { remapSensorKeys } from '../utils/index.js';
import config from '../config';

const initialDataState = {
  pending: false,
  error: false,
  current: {
    sensors: [],
  },
  ...initialData,
}

export function data(state = initialDataState, action) {
  switch (action.type) {
    case FETCH_CURRENT_REQUEST:
      return {
        ...state,
        pending: true,
      }
    case FETCH_CURRENT_SUCCESS:
      return {
        ...state,
        pending: false,
        error: false,
        current: {
          ...action.payload,
          sensors: remapSensorKeys(action.payload.sensors, config.sensors.nameMap),
        },
      }
    case FETCH_CURRENT_FAILED:
      return {
        ...state,
        pending: false,
        error: true,
        errorResponse: action.payload,
      }
    default:
      return state
  }
}

const initialAppState = {
  panels: {
    1: {
      type: 'scrolling',
      config: {
        screens: [
          {
            keys: ['temp_last', 'hum_last'],
            title: 'Temperature & Humidity',
          },
          {
            keys: ['wetness_last', 'moist_soil_last', 'rain_day_mm'],
            title: 'Soil, Leaf wetness & Rain (last 24hrs)', // TODO: Make user configurable
          },
          {
            keys: ['wind_dir', 'wind_speed'],
            title: 'Wind Speed and Direction',
          },
          {
            keys: ['wet_bulb_last', 'solar_rad'],
            title: 'Globe Temperature & Solar Radiation',
          },
        ]
      }
    },
    2: {
      type: 'nodes',
      config: {
        keys: ['temp_last', 'hum_last'],
        title: 'Temperature & Humidity',
      },
    },
    3: {
      type: 'nodes',
      config: {
        keys: ['wetness_last', 'moist_soil_last', 'rain_day_mm'],
        title: 'Soil, Leaf wetness & Rain (last 24hrs)', // TODO: Make user configurable
      }
    },
    4: {
      type: 'nodes',
      config: {
        keys: ['wind_dir', 'wind_speed'],
        title: 'Wind Speed and Direction',
      }
    },
  },
}

export function app(state = initialAppState, action) {
  switch (action.type) {
    case SWITCH_TYPE:
      return {
        ...state,
        panels: {
          ...state.panels,
          [action.meta.id]: {
            ...state.panels[action.meta.id],
            type: action.payload,
          }
        },
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers.js